export enum PAYMENT_STATUS {
	FAILED = 'failed',
    INCOMPLETE = 'incomplete'
}

export enum SUB_TREATMENT {
	HCP_STRIPE_PLATFORM = 'HCP_STRIPE_PLATFORM',
}